import spinners from '@components/loader/spinners'

import('./load_component.css')

export default function LoadComponent(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div', 'view-chart-loading-container')
        elements.content = this.createElement('div', 'view-chart-loading-content')
        
        $(elements.container).append(elements.content)
        $(container).append(elements.container)
    }

    this.show = type =>{
        if(type == 'loading'){
            generateContentLoading()
        } else {
            generateContentError()
        }
        $(elements.container).addClass('show')
    }

    this.hide = _ =>{
        $(elements.container).removeClass('show')
    }

    const generateContentError = _ =>{
        $(elements.content).html('')
        let text = context.createElement('div', 'mb-2 font-weight-bold font-size-lg text-uppercase', 'Erro ao carregar dados <i class="far fa-surprise"></i>')
        let button = context.createElement('button', 'btn-reload-all', 'RECARREGAR')
        button.type = 'button'

        $(button).on('click', _ =>{
            context.trigger('button-reload:click')
        })

        $(elements.content).append(text, button)
    }

    const generateContentLoading = _ =>{
        $(elements.content).html('')
        elements.loader = this.createElement('div', 'flex flex-v flex-v-center flex-h-center', '')

        let label = this.createElement('div', 'mb-2 font-weight-bold font-size-lg', 'CARREGANDO DADOS')

        $(elements.loader).append(label,spinners.defaultSpinner(1, '', 'md'))

        $(elements.content).append(elements.loader)
    }

}

LoadComponent.prototype = Object.create(BaseConstructor.prototype)